export const BUSINESS_SETTINGS_QUERY_KEY = 'businessSettings'
export const BUSINESS_MODULES_SETTINGS_QUERY_KEY = 'businessModulesSettings'
export const BUSINESS_SETTINGS_BRIEF_QUERY_KEY = 'businessSettingsBrief'
export const ANONYMOUSLY_TELEGRAM_INTEGRATION_QUERY_KEY = 'anonymouslyTelegramIntegration'
